__turbopack_context__.v({
  "normalizedFilesBlockWrapper": "NormalizedFileBlock-module-scss-module__wJb6Qa__normalizedFilesBlockWrapper",
});
